import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LoggedInGuard } from '../auth/logged-in-guard.service';
import { SuperuserServiceModule } from './superuser-service.module';

/**
 * This service is used to check if user is allowed to navigate to certain route.
 */
@Injectable({
  providedIn: SuperuserServiceModule
})
export class SuperuserPermissionGuard implements CanActivate, CanLoad {

  /**
   * Default constructor
   *
   * @param {AuthService} auth
   */
  constructor(private auth: AuthService, private router: Router) {
  }

  /**
   * Checker function for valid permission.
   * @returns {boolean} - allowed true/false
   */
  canActivate() {
    const requiredUiPermission = 'superuser';
    if(this.auth.hasPermission(requiredUiPermission)) {
      return true;
    }
    // navigate back home
    // TODO: parameterize this somehow?
    this.router.navigate(['/home']);
    return false;
  }

  canLoad() {
    return this.canActivate();
  }

}
